import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";

import Navbar from "./components/Navbar";
import HomeIndex from "./pages/home/Index";
import ToolsIndex from "./pages/tools/Index";
import ConvertImages from "./pages/convert-images/Index";
import PasswordGenerator from "./pages/password-generator/Index";
import Pandin from "./pages/pandin/Index";
import Sidebar from "./components/Sidebar";
import Dashboard from "./pages/dashboard/Index";
import Footer from "./components/Footer";

function SidebarLayout({ children }) {
  const location = useLocation();
  return (
    <div className="d-flex pandin-layout">
      {location.pathname === "/pandin" ? null : <Sidebar />}

      <div style={{ flex: 1 }}>{children}</div>
    </div>
  );
}

function AppContent() {
  const location = useLocation();

  return (
    <>
      {location.pathname === "/dashboard" ||
      location.pathname === "/pandin" ? null : (
        <Navbar />
      )}
      <Routes>
        <Route path="/" element={<HomeIndex />} />
        <Route path="/tools" element={<ToolsIndex />} />
        <Route path="/convert-images" element={<ConvertImages />} />
        <Route path="/password-generator" element={<PasswordGenerator />} />
        <Route
          path="/pandin"
          element={
            <SidebarLayout>
              <Pandin />
            </SidebarLayout>
          }
        />
        <Route
          path="/dashboard"
          element={
            <SidebarLayout>
              <Dashboard />
            </SidebarLayout>
          }
        />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
      <Footer />
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
